/* TCE UI — tiny global behaviours for the .tce marketing pages.
   Moved out of per-page inline <script> blocks (the data layer) so the program
   lives in one place. Currently: the button "press" affordance — adds
   .is-pressed on mousedown (styled in tce-base.css) and clears it shortly after. */
(function () {
  document.addEventListener('mousedown', function (e) {
    var b = e.target.closest('.btn');
    if (!b) return;
    b.classList.add('is-pressed');
    setTimeout(function () { b.classList.remove('is-pressed'); }, 220);
  });
})();
